import { LocalStorageProvider } from '@/models/storages/local-storage-provider';

export const SessionStorage = new LocalStorageProvider();
